module.exports = __webpack_public_path__ + "img/cold.d0f9cd39.svg";